module.exports = __webpack_public_path__ + "img/business.0f843925.png";